export enum DisputeInformationMaxLengthsEnum {
  CUSTOMER_REFERENCE_NUMBER = 50,
}
